import Vue from 'vue'
import VueRouter from 'vue-router'
import Kredit from '@/components/kredit'
import Profil from '@/components/profil'
import Balicky from '@/components/balicky'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/kredit',
    name: 'Kredit',
    component: Kredit
  },
  {
    path: '/profil',
    name: 'Profil',
    component: Profil
  },
  {
    path: '/balicky',
    name: 'Balicky',
    component: Balicky
  },
  {
    path: '/travel',
    name: 'Roaming',
    component: () => import('../views/Roaming.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/vitajte',
    name: 'Vitajte',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/zmena-programu',
    name: 'Zmena',
    component: () => import('../views/Zmena.vue')
  },
  // {
  //   path: '/zmena',
  //   name: 'Info',
  //   component: () => import('../views/Info.vue')
  // },
  {
    path: '/ponuka*',
    name: 'Ponuka',
    component: () => import('../views/Ponuka.vue')
  },
  {
    path: '/viac-dat',
    name: 'ViacData',
    component: () => import('../views/ViacDat.vue')
  },
  {
    path: '/nekonecno',
    name: 'Nekonecno',
    component: () => import('../views/Nekonecno.vue')
  },
  {
    path: '/data',
    name: 'Data',
    component: () => import('../views/Data.vue')
  },
  {
    path: '/app/:target',
    name: 'Decide',
    component: () => import('../views/Decide.vue')
  },
  {
    path: '/app',
    name: 'DecideRoot',
    component: () => import('../views/Decide.vue')
  },
  {
    path: '/potvrdenie-aktivacie',
    name: 'RCSAction',
    component: () => import('../views/RCSAction.vue')
  },
  {
    path: '/validate',
    name: 'Validate',
    component: () => import('../views/Validate.vue')
  },
  {
    path: '/manage/:msisdn',
    name: 'Manage',
    component: () => import('../views/Manage.vue'),
    props: route => ({ msisdn: route.params.msisdn })
  },
  {
    path: '/*',
    name: 'Home',
    component: Kredit
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
